module.exports = __webpack_public_path__ + "img/services-01-portrait.39a86229.jpg";